import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Info } from 'lucide-react';

/**
 * Tells the user what creating a record by hand means: nothing typed into a form
 * is attested, so its facts start on the Sandbox Plane as candidate claims.
 * Shown on Review, where the user is about to commit to it.
 */
function SandboxNotice({ name }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div role="note" className="flex gap-3 rounded-lg border border-sky-400/25 bg-sky-500/10 p-4">
      <Info className="mt-0.5 size-5 shrink-0 text-sky-400" aria-hidden />
      <div className="flex flex-col gap-1">
        <p className="text-sm font-semibold text-content">{t('create.review.sandbox.title')}</p>
        <p className="text-sm text-content-secondary">{t('create.review.sandbox.body', { name })}</p>
      </div>
    </div>
  );
}

export default memo(SandboxNotice);
